export default __webpack_public_path__ + "assets/hero_640.5a4f8888.webp";